import React from "react";
import { Link } from "react-router-dom";
import { Lightning } from "@phosphor-icons/react";

const cols = [
  {
    title: "Platform",
    links: [
      { to: "/workers", label: "Find Workers" },
      { to: "/jobs", label: "Browse Jobs" },
      { to: "/pricing", label: "Pricing" },
      { to: "/blog", label: "Blog" },
      { to: "/support", label: "Contact Support" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/legal/privacy", label: "Privacy Policy" },
      { to: "/legal/terms", label: "Terms of Service" },
      { to: "/legal/refund", label: "Refund Policy" },
      { to: "/legal/contractor", label: "Contractor Disclaimer" },
    ],
  },
  {
    title: "Community",
    links: [
      { to: "/legal/community", label: "Community Guidelines" },
      { to: "/report", label: "Report a User" },
      { to: "/settings", label: "Account Settings" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <img src="/canhiresolution-logo.png" alt="CanHireSolution.com" className="h-9 w-auto max-w-[160px] object-contain" />
            <span className="font-display text-lg">Can<span className="text-accent-red">Hire</span>Solution<span className="text-accent-red">.com</span></span>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed">
            Canada&apos;s hiring platform for temp jobs, skilled trades, freelancers, and virtual staff. Built for homeowners, small businesses, and founders.
          </p>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-3">{c.title}</div>
            <ul className="space-y-2">
              {c.links.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-slate-700 hover:text-brand" data-testid={`footer-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} CanHireSolution.com Inc. All rights reserved.</span>
          <span>Made in Canada · PIPEDA compliant</span>
        </div>
      </div>
    </footer>
  );
}
